import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  NOTIFICATIONS_FEATURE_KEY,
  NotificationsState,
} from './notifications.reducer';

export const getNotificationsState = createFeatureSelector<NotificationsState>(
  NOTIFICATIONS_FEATURE_KEY
);

export const selectLoaded = createSelector(
  getNotificationsState,
  (s) => s.isLoaded
);

export const selectItems = createSelector(
  getNotificationsState,
  (s) => s.notifications
);

export const unreadCount = createSelector(
  getNotificationsState,
  (s) => s.unreadCount
);
